import { Pencil, Trash2, KeyRound, ShieldCheck } from "lucide-react";
import { ROLE_LABEL } from "./roleLabels";

export const EmployeeRow = ({ employee: e, canWrite, canDelete, isAdmin, openEdit, onDelete, onClearPin }) => (
  <tr
    data-testid={`employee-row-${e.id}`}
    onDoubleClick={() => canWrite && openEdit(e)}
    onClick={() => {
      if (canWrite && typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches) {
        openEdit(e);
      }
    }}
    title={canWrite ? "Double-click to edit (tap on mobile)" : undefined}
    className={`border-t border-[#33424f]/10 hover:bg-[#f5f1ec] ${canWrite ? "cursor-pointer select-none" : ""}`}
  >
    <td className="px-6 py-3 font-semibold">{e.name}</td>
    <td className="px-6 py-3">{ROLE_LABEL[e.role] || e.role}</td>
    <td className="px-6 py-3" data-testid={`employee-login-status-${e.id}`}>
      {e.login_enabled ? (
        <span className="inline-flex items-center gap-1 text-[10px] subtitle uppercase tracking-[0.2em] text-[#1f4715] bg-[#e6f1df] border border-[#2d5e1f]/30 px-2 py-0.5">
          <ShieldCheck className="w-3 h-3" /> {e.username}
        </span>
      ) : (
        <span className="text-[10px] subtitle uppercase tracking-[0.2em] text-[#50493b]/60">No login</span>
      )}
    </td>
    <td className="px-6 py-3">
      <span className={`text-xs font-semibold uppercase tracking-wider ${e.active ? "text-[#2d5e1f]" : "text-[#50493b]"}`}>
        {e.active ? "Active" : "Archived"}
      </span>
    </td>
    <td className="px-6 py-3 text-right" onDoubleClick={(ev) => ev.stopPropagation()}>
      {isAdmin && e.login_enabled && (
        <button
          data-testid={`revoke-login-${e.id}`}
          onClick={() => onClearPin(e)}
          className="p-1.5 hover:bg-[#fbf1dc] text-[#b9832a]"
          title="Revoke login (clear PIN)"
        >
          <KeyRound className="w-4 h-4" />
        </button>
      )}
      {canWrite && (
        <button
          data-testid={`edit-employee-${e.id}`}
          onClick={() => openEdit(e)}
          className="p-1.5 hover:bg-[#e6e0db] text-[#33424f] ml-1"
        >
          <Pencil className="w-4 h-4" />
        </button>
      )}
      {canDelete && (
        <button
          data-testid={`delete-employee-${e.id}`}
          onClick={() => onDelete(e)}
          className="p-1.5 hover:bg-[#fbe4ea] text-[#b30035] ml-1"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      )}
    </td>
  </tr>
);
